export default __webpack_public_path__ + "static/media/unionpay.64825b18.svg";